
import ReactPlaceholder from 'react-placeholder';
import "react-placeholder/lib/reactPlaceholder.css";
import { useState, useEffect } from "react";

const Section = () => {

  const [ready, setReady] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setReady(true)
    }, 1000);
  }, [])

  const checkMarks = [
    "Prescription and doctor messaging or consult",
    "Discounted medication",
    "Referral to in-person care if needed",
    "HSA and FSA Eligible",
    "Itemized receipt for 70% out-of-network reimbursement",
  ];
  const crossMarks = [
    "Cost of medication not included",
    "Not responsible for copays or deductibles if insurance is used at the lab",
    "Discounted prices shown include use of insurance at lab, crossed out prices are fully out-of-pocket",
  ];
  return (
    <div className="main-benifit-wrapper">
      <div className="main-partner-pres-section mt-3">
        <div className="container">
          <div className="benefit-lists">
            <div className="benefit-lists1">
            <ReactPlaceholder showLoadingAnimation ready={ready} rows={1} style={{ fontSize: "10px",marginBottom:"10px", width:"50%" }}>
              <span>The following benefits and limitations apply:</span>
              </ReactPlaceholder>

              <div className="partner-section-list">
                  <ReactPlaceholder showLoadingAnimation ready={ready} rows={5} style={{ fontSize: "10px",marginBottom:"10px" }}>
                {" "}
                <ul>
                  {checkMarks.map((element, key) => (
                    <li>{element}</li>
                    ))}
                </ul>
                    </ReactPlaceholder>
                <div className="offset-md-1 col-md-5">
                  <div className="partner-section-list-1">
                  <ReactPlaceholder showLoadingAnimation ready={ready} rows={4} style={{ fontSize: "10px",marginBottom:"10px" }}>
                    <ul>
                      {crossMarks.map((element, key) => (
                        <li>{element} </li>
                      ))}
                    </ul>
                    </ReactPlaceholder>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Section;
